module.exports = __webpack_public_path__ + "assets/img/left-title-open-1f24aa03.png";